var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('talent-info',{attrs:{"pageName":"clueSeas","row":_vm.row},on:{"goDetail":_vm.showDetailDrawer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }